import { Link, useNavigate } from 'react-router-dom';
import './style/Home.css';
import TopNavbar from './TopNavbar';
import { useEffect, useState } from 'react';
import { API_CONFIG } from './../../config';
import StudyOption from '../AllData/HomeData';

const CREATE_USER_ENDPOINT = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPINSTALLSEND}`;

const PUSH_APPITEMSUSE = `${API_CONFIG.BASE_URL}${API_CONFIG.ENDPOINTS.APPITEMSUSEPUSH}`;


function Home() {
  const studyOptions = StudyOption;

  const activeOptions = studyOptions.filter(option => option.status === "true");


  var name = "to Gate Prep App";


  useEffect(() => {
    window.history.pushState(null, null, window.location.pathname);

    const handleBackButton = () => {
      window.history.pushState(null, null, window.location.pathname);
    };
    window.addEventListener('popstate', handleBackButton);
    return () => window.removeEventListener('popstate', handleBackButton);

  }, []);


  useEffect(() => {
    const trackNewUser = async () => {
      if (!localStorage.getItem('tracked')) {
        const generatedId = 'USER-' + Math.random().toString(36).substr(2, 9).toUpperCase();
        try {
          const response = await fetch(CREATE_USER_ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: 'userId=' + encodeURIComponent(generatedId)
          });

          if (response.ok) {
            localStorage.setItem('tracked', 'true');
            console.log("User Tracked:", generatedId);
          }
        } catch (error) {
          console.error("Tracking error:", error);
        }
      }
    };

    trackNewUser();
  }, []);




  // 1. Updated ItemClick function to take the 'option' object dynamically
  const ItemClick = async (option) => {
    const formData = {
      name: option.name,
      type: option.id
    };

    try {
      await fetch(PUSH_APPITEMSUSE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    } catch (error) {
      console.error('Submission error:', error.message);
    }
  };






  return (
    <div className="study-app">

      <TopNavbar name={name} />

      <header className="app-header">
        <h1>🎯 Gate Exam Preparation</h1>
      </header>

      <br></br>



      <div className="study-grid">
        {activeOptions.map((option) => {


          return (
            <Link
              to={option.link}
              key={option.id}
              className="study-card-link"
              onClick={() => ItemClick(option)}
            >
              <div
                className="study-card"
                style={{ position: 'relative' }}
              >

                <div className="card-row">
                  <div className="card-icon">
                    <span style={{ fontSize: '70px', lineHeight: 1 }}>
                      {option.symbol}
                    </span>
                  </div>
                  <h3>{option.name} →</h3>
                </div>



              </div>
            </Link>
          );
        })}
      </div>

  
      <br></br><br></br>

      


      <br></br><br></br>
      

    </div>
  );
}

export default Home;